import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
const styledSectionCss = "smcstf0";
const styledSectionWithBorderCss = "s1ayg3ci";
const StyledSection = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    withBottomBorder,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(withBottomBorder ? styledSectionWithBorderCss : styledSectionCss, props.className)} />;
});
const styledSectionHeaderCss = "s3p0qpb";
const StyledSectionHeader = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(styledSectionHeaderCss, props.className)} />;
});
const styledSectionHeaderRowCss = "sibwotl";
const StyledSectionHeaderRow = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(styledSectionHeaderRowCss, props.className)} />;
});
const styledSectionBodyUsePaddingCss = "s1o3dvzy";
const styledSectionBodyCss = "s1t6rdwp";
const styledSectionBodyWithBorderCss = "ssu4o93";
const StyledSectionBody = forwardRef((props, ref) => {
  const {
    usePadding,
    showBorder = true,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(styledSectionBodyCss, {
    [styledSectionBodyUsePaddingCss]: usePadding,
    [styledSectionBodyWithBorderCss]: showBorder
  }, props.className)} />;
});
export const WidgetContainer = ({
  title,
  subtitle,
  header,
  children,
  noPadding = false,
  showBorder = true,
  sectionWithBottomBorder = false
}) => <StyledSection withBottomBorder={sectionWithBottomBorder}>
    <StyledSectionHeader>
      <StyledSectionHeaderRow>
        <BodyText weight="bold" size="large">{title}</BodyText>
        {subtitle && <BodyText color="muted" size="medium">{subtitle}</BodyText>}
        {header}
      </StyledSectionHeaderRow>
    </StyledSectionHeader>
    <StyledSectionBody usePadding={!noPadding} showBorder={showBorder}>
      {children}
    </StyledSectionBody>
  </StyledSection>;

require("./widget_container.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./widget_container.js");